export {};

declare global {
    interface Promise<T> {
        finally: (finallyFn?: () => void) => Promise<T>;
    }
}

// zonejs should already define it
if (!Promise.prototype.finally) {
    Promise.prototype.finally = function (callbackFn: () => any) {
        this.then(
            () => callbackFn(),
            () => callbackFn(),
        );
        return this;
    };
}
